import { call, put, SagaReturnType, select, takeEvery } from 'redux-saga/effects';
import { doSucceededGetPositionList } from 'src/actions';
import { State, Type } from 'src/actions/utils';
import { getClientApi, PositionApi, PrivateQuotesApi } from 'src/data-communication';
import { GetPositionListDto, GetPrivateQuotesSnapResponseDto } from 'src/dtos';
import { mapPositionListDtoToModel } from 'src/mappers';

import { TReduxAction } from '../typings/commonTypes';
import { Logger } from '../utils/Logger';

import { safeSaga } from './utils';

function* list(action: TReduxAction) {
  const { authToken } = yield select(state => state.auth.data);
  const dto: GetPositionListDto = action?.payload;
  const { data, total }: SagaReturnType<PositionApi['list']> = yield call(getClientApi().position.list, {
    ...dto,
    authToken,
  });
  const privateQuotesResponse: SagaReturnType<PrivateQuotesApi['getMany']> = yield call(
    getClientApi().privateQuotes.getMany,
    authToken,
  );

  let privateQuotesSnap: GetPrivateQuotesSnapResponseDto = { data: [], total: 0 };

  try {
    const symbols = privateQuotesResponse.data.map(aPrivateQuoteDto => aPrivateQuoteDto.symbol);
    privateQuotesSnap = yield call(getClientApi().privateQuotes.snap, symbols, authToken);
  } catch (error) {
    Logger.error(`Error getting private quote snap list:`, error);
    Logger.info('Fallback: use empty private quote snap list');
  }

  const positionList = mapPositionListDtoToModel(data, privateQuotesResponse.data, privateQuotesSnap.data);
  yield put(doSucceededGetPositionList({ data: positionList, total }));
}

export function* registerPositionSagas() {
  yield takeEvery(State.actionRequested(Type.GET_POSITION_LIST), safeSaga(list, Type.GET_POSITION_LIST));
  yield takeEvery(Type.REFRESH_POSITION_LIST, safeSaga(list, Type.REFRESH_POSITION_LIST));
}
